
import { __ } from 'bits/intl'
import { Component, Prop, Vue } from 'bits/vue'
import BaseIcon from 'vuecomponents/base_icon.vue'
import LocaleSelector from 'vuecomponents/locale_selector.vue'
import KeyboardTrapMixin from 'vuemixins/modal_keyboard_trap_mixin'

@Component({
  components: {
    BaseIcon,
    LocaleSelector,
  },
  mixins: [KeyboardTrapMixin],
})
export default class Dropdown extends Vue {
  @Prop() title!: string
  @Prop() items!: Record<string, any>[]
  openModal!: (modalNodes: NodeList | Node[]) => void // from KeyboardTrapMixin
  closeModal!: () => void // from KeyboardTrapMixin
  isModalOpen!: boolean // from KeyboardTrapMixin
  dialogDescription = __(
    'Beginning of dialog window. It begins with a button called Close. Escape will cancel and close the window.',
  )

  get backdropClass(): object {
    return {
      show: this.isModalOpen,
      backdrop: true,
    }
  }

  get menuClass(): object {
    return {
      show: this.isModalOpen,
      'sub-menu': true,
    }
  }

  handleMenu(): void {
    // find the menu and its focusable children
    const menu = document.querySelector('.sub-menu') as HTMLElement
    const focusableElementsString = 'select, a, button'
    let menuNodes: NodeList | Node[] = menu.querySelectorAll(focusableElementsString)
    menuNodes = Array.from(menuNodes)

    this.openModal(menuNodes)
  }
}
